import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../../../../../common/state';
import { changeOfferId } from '../../../../../../state/advanced/offer_id';

import { OfferId as OfferIdComponent } from './offerId';

export const OfferId = connect(
  (state: IAppState) => ({
    value: state.filters.jsonQuery.id && state.filters.jsonQuery.id.value,
  }),
  (dispatch: Dispatch) => ({
    onChange: (value?: number | undefined) => {
      dispatch(changeOfferId(value));
    },
  }),
)(OfferIdComponent);
